import React from 'react';
import DateOptions from './DateOptions';

export default function ColumnOptions(props) {
    const { column } = props;

    switch (parseInt(column.column_type_id)) {
        case 4:
        case 16:
            return <DateOptions {...props} />
        default:
            return ""
    }
}
